import React, { PureComponent } from 'react'
import { Button, Form, Message, Modal, Icon } from 'semantic-ui-react'
import { Redirect } from 'react-router-dom'
import { register } from '../../services/self'
import { confirmMarketplaceSubscription } from '../../services/api-catalog'
import logo from '../../logo.png'

 export default class Register extends PureComponent {
  state = {
    isSubmitting: false,
    signedIn: false,
    errorMessage: '',
    isOpen: false
  }

  open = () => this.setState({ isSubmitting: false, errorMessage: '', isOpen: true })
  close = () => this.setState({ isOpen: false })
  handleRegister = (...args) => this._handleRegister(...args)

  _handleRegister(event, serializedForm) {
    event.preventDefault()
    this.setState({isSubmitting: true})
    console.log(serializedForm.application);
    register(serializedForm.email, serializedForm.password, serializedForm.application)
    .then(() => {
        this.setState({signedIn: false, isSubmitting: false, errorMessage: "Account registration is successful, however Admin's confirmation is needed. Please login after an hour."})

        const { usagePlanId, token } = this.props

        if (usagePlanId && token) {
   	       return confirmMarketplaceSubscription(usagePlanId, token)
        }
      })
    .catch((e) => this.setState({errorMessage: e.message, isSubmitting: false}))
  }

  render() {
    const { isOpen } = this.state

    return this.state.signedIn ? <Redirect to='/' /> : (
      <Modal
        size='small'
        className = "modalRegister"
        open={isOpen}
        onOpen={this.open}
        onClose={this.close}
        trigger={<Button className="registerBtn">REGISTER</Button>}
      >
        <div className="centerHeader">
          <br/>
          <span style={{fontSize: '25px'}}>Get started by signing up</span>
          <br/>
        </div>
        <Modal.Content>
          <Icon name="close" size="big" style={{position:"absolute", top:"15px", right:"10px", color: "#C0C0C0"}} onClick={this.close}/>
          <div className="wrapper">
            <Form onSubmit={this.handleRegister} error={!!this.state.errorMessage} loading={this.state.isSubmitting}>
            <Message error content={this.state.errorMessage} />
              <div className="form-group">
                <input name='email' className="form-control formText inputPadding" placeholder="Email"/>
              </div>
              <div className="form-group">
                <input name='application' className="form-control formText inputPadding" placeholder="Application"/>
              </div>
              <div className="form-group">
                <input type='password' name='password' autoComplete='false' className="form-control formText inputPadding" placeholder="Password"/>
              </div>
              <Modal.Actions style={{textAlign: 'right', paddingTop:'10px'}}>
                <Button type='submit' color='green' size='big'><span className="modalBtn">REGISTER</span></Button>
              </Modal.Actions>
            </Form>
          </div>
        </Modal.Content>
      </Modal>)
    }
}



/** WEBPACK FOOTER **
 ** ./src/components/Register/index.js
 **/